define(["require", "exports", "tslib", "config", "@arcgis/core/config", "mobx", "react", "../model/search/Search", "../model/services/AppConfigManager", "../model/services/EventManager", "../model/services/SrmsServiceManager", "../utils/Environment", "../utils/GeometryUtil", "../utils/UrlUtil", "./Events"], function (require, exports, tslib_1, webConfig, config_1, mobx_1, React, Search_1, AppConfigManager_1, EventManager_1, SrmsServiceManager_1, Environment_1, GeometryUtil_1, UrlUtil_1, Events_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ConfigStore = void 0;
    config_1 = tslib_1.__importDefault(config_1);
    React = tslib_1.__importStar(React);
    class ConfigStore {
        get BaseUrl() {
            var _a;
            return ((_a = this.WebConfig) === null || _a === void 0 ? void 0 : _a.baseUrl) || "/";
        }
        constructor(storeManager) {
            var _a, _b, _c;
            Object.defineProperty(this, "storeManager", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsLoaded", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "WebConfig", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AppConfig", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SearchConfig", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "geometryServiceUrl", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.storeManager = storeManager;
            try {
                (0, EventManager_1.notify)("Loading Configuration");
                this.WebConfig = webConfig;
                this.WebConfig = this.normaliseConfig(this.WebConfig);
                let restApi = this.WebConfig.services.find((x) => x.id.toUpperCase() == "REST_API");
                if (!restApi) {
                    throw new Error("Configuration should contain a service definition with an id of REST_API");
                }
                SrmsServiceManager_1.SrmsServiceManager.HttpProtocol = restApi.protocol || window.location.protocol.replace(":", "").replace("//", "");
                SrmsServiceManager_1.SrmsServiceManager.HostName = restApi.host || window.location.host;
                SrmsServiceManager_1.SrmsServiceManager.ServiceName = restApi.instance;
                SrmsServiceManager_1.SrmsServiceManager.ProxyUrl = restApi.proxyUrl;
                this.geometryServiceUrl = this.WebConfig.geometryService.url;
                config_1.default.geometryServiceUrl = this.WebConfig.geometryService.url;
                for (const service of this.WebConfig.services) {
                    if (service.proxyUrl) {
                        (_a = config_1.default.request.proxyRules) === null || _a === void 0 ? void 0 : _a.push({
                            urlPrefix: service.host.replace(/(http(s)?:\/\/)|(:\d{1,}.+)/i, ""),
                            proxyUrl: `${(0, UrlUtil_1.buildUrl)(window.location.protocol, window.location.host, service.proxyUrl)}`,
                        });
                    }
                }
                (_b = config_1.default.request.interceptors) === null || _b === void 0 ? void 0 : _b.push({
                    urls: /\/FeatureServer\/\d\/query/,
                    before: (params) => {
                        if (/\/0\/query/.test(params.url)) {
                            params.requestOptions.query.maxAllowableOffset = 5;
                        }
                        else {
                            const map = this.storeManager.mapStore.Map;
                            const offset = GeometryUtil_1.GeometryUtil.getMaxAllowableOffset(map);
                            params.requestOptions.query.maxAllowableOffset = offset;
                        }
                    },
                });
                (_c = config_1.default.request.interceptors) === null || _c === void 0 ? void 0 : _c.push({
                    urls: /MapServer/,
                    after: (params) => {
                        var _a, _b, _c, _d, _e, _f, _g;
                        if ((_a = params === null || params === void 0 ? void 0 : params.data) === null || _a === void 0 ? void 0 : _a.singleFusedMapCache) {
                            if (((_b = params === null || params === void 0 ? void 0 : params.data) === null || _b === void 0 ? void 0 : _b.minLOD) !== undefined) {
                                params.data.minLOD = 0;
                            }
                            if (((_c = params === null || params === void 0 ? void 0 : params.data) === null || _c === void 0 ? void 0 : _c.maxLOD) !== undefined) {
                                params.data.maxLOD =
                                    (_g = ((_f = (_e = (_d = params === null || params === void 0 ? void 0 : params.data) === null || _d === void 0 ? void 0 : _d.tileInfo) === null || _e === void 0 ? void 0 : _e.lods) === null || _f === void 0 ? void 0 : _f.length) - 1) !== null && _g !== void 0 ? _g : undefined;
                            }
                        }
                    },
                });
                AppConfigManager_1.AppConfigManager.Instance.then((appConfig) => {
                    this.IsLoaded = true;
                    this.AppConfig = appConfig;
                    EventManager_1.EventManager.Instance.emitAsync(Events_1.CONFIG_READY_EVENT, this);
                    if ((0, Environment_1.isTest)()) {
                        const body = (React.createElement("div", null,
                            React.createElement("p", null, "This site is a test version of the SRMS. It is to be used for product testing and evaluation only. All actions performed within this environment are void."),
                            React.createElement("p", null,
                                "For assistance, please contact",
                                " ",
                                React.createElement("a", { href: `mailto:${appConfig.ActiveConfiguration()
                                        .Configuration.Email.SrmsSupport
                                        .Email}` }, "Support"))));
                        this.storeManager.modalStore.createInfoModal("User Acceptance Testing Environment", body);
                    }
                });
            }
            catch (err) {
                EventManager_1.EventManager.Instance.emitError(err);
            }
        }
        loadSearchConfig() {
            return new Promise((resolve, reject) => {
                if (!this.SearchConfig) {
                    (0, EventManager_1.notify)("Loading Search");
                    try {
                        new Promise((resolve_1, reject_1) => { require(["searchConfig"], resolve_1, reject_1); }).then(tslib_1.__importStar).then((config) => {
                            this.SearchConfig = new Search_1.SearchConfig(this.normaliseConfig(config));
                            resolve(this.SearchConfig);
                        });
                    }
                    catch (err) {
                        (0, EventManager_1.emitError)(err);
                        reject(err);
                    }
                }
                else {
                    resolve(this.SearchConfig);
                }
            });
        }
        get Snapping() {
            if (!this.WebConfig.entityView.Core ||
                !this.WebConfig.entityView.Core.Snapping) {
                throw new Error("Snapping configuration not found");
            }
            return this.WebConfig.entityView.Core.Snapping;
        }
        get GaTrackingEnabled() {
            return this.WebConfig.ga.enabled;
        }
        get GaTrackingId() {
            return this.WebConfig.ga.trackingId;
        }
        normaliseConfig(config) {
            const { services } = this.WebConfig;
            let raw = JSON.stringify(config);
            for (let service of services) {
                const url = `${service.protocol}://${service.host}/${service.instance}/rest/services`;
                raw = raw.replace(new RegExp(`\{${service.id}\}`, "gi"), url);
            }
            let updated = JSON.parse(raw);
            return updated;
        }
    }
    exports.ConfigStore = ConfigStore;
    tslib_1.__decorate([
        mobx_1.observable
    ], ConfigStore.prototype, "IsLoaded", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ConfigStore.prototype, "WebConfig", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ConfigStore.prototype, "AppConfig", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ConfigStore.prototype, "SearchConfig", void 0);
});
